import type { WorkspaceMotionProfile } from '../../../core/policies/workspace/visual-theme-profile';

interface ReducedMotionMediaQueryLike {
	matches: boolean;
}

export function resolveGraphMotionProfile(
	prefersReducedMotion: boolean | ReducedMotionMediaQueryLike | null | undefined,
): WorkspaceMotionProfile {
	if (typeof prefersReducedMotion === 'boolean') {
		return prefersReducedMotion ? 'reduced' : 'default';
	}

	return prefersReducedMotion?.matches ? 'reduced' : 'default';
}

export function detectGraphMotionProfile(
	matchMedia: ((query: string) => ReducedMotionMediaQueryLike) | null | undefined =
		typeof window !== 'undefined' && typeof window.matchMedia === 'function'
			? window.matchMedia.bind(window)
			: undefined,
): WorkspaceMotionProfile {
	if (!matchMedia) {
		return 'default';
	}

	return resolveGraphMotionProfile(matchMedia('(prefers-reduced-motion: reduce)'));
}